import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import axios from "axios";

interface ScanImgRequest {
    s_bl_no: string;
}

interface ScanImgResponse {
    statusCode: number;
    message: string;
    data: {
        url: string;
        filename: string;
        size_kb: string;
        generated_at: string;
        timestamp: number;
    };
}

export const usePostScanImg = (
    onSuccessCallback?: (data: ScanImgResponse) => void,
): UseMutationResult<ScanImgResponse, Error, ScanImgRequest> => {
    const queryClient = useQueryClient();
    const c_code = useMorningAuthStore(state => state.c_code ?? "");

    return useMutation<ScanImgResponse, Error, ScanImgRequest>({
        mutationFn: async (body: ScanImgRequest) => {
            const requester = c_code ? axiosInstance : axios;

            const res = await requester.post(enum_api_uri.scan_img.replace(":s_bl_no", body.s_bl_no));
            return res.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["usePostTmpList"] });
            onSuccessCallback?.(data);
        },
    });
};
